export default __webpack_public_path__ + "static/media/lithuania.e49fa64e.svg";